<template>
  <section class="su-team">
    <div
      v-if="title"
      class="main-title"
      v-html="title"
    />
    <div
      v-else
      class="su-title"
    >
      <p>команда</p>
      <h2>
        <span>обучайтесь комфортно дома</span>
        с&nbsp;помощью лучших преподавателей и&nbsp;команды специалистов
      </h2>
    </div>

    <div class="su-team__btns">
      <button
        v-for="button in team"
        :key="button.id"
        :class="['m-btn su-team__btn', { 'su-team__btn--active': activeTeamId === button.id }]"
        @click="activeTeamId = button.id"
      >
        {{ button.btn }}
      </button>
    </div>

    <div class="su-team__body">
      <h6
        class="su-team__body_title"
        v-html="activeTeam.title"
      />
      <img
        :src="`/v2/school-university/team/${activeTeamUser.img}.webp`"
        :alt="activeTeamUser.name"
        class="su-team__body_img"
        loading="lazy"
      >
      <div class="su-team__body_info">
        <div class="su-team__body_cheap">
          <span
            v-for="(cheap, index) in activeTeamUser.cheap"
            :key="index"
          >
            {{ cheap }}
          </span>
        </div>
        <p
          class="su-team__body_name"
          v-html="activeTeamUser.name"
        />
        <p
          class="su-team__body_text"
          v-html="activeTeamUser.description"
        />

        <div
          v-if="suTablet ? activeTeam.items.length : activeTeam.items.length > 1"
          class="su-team__body_timer"
        >
          <button
            v-for="(user, index) in activeTeam.items"
            :key="index"
            :class="[
              'm-btn su-team__body_timer_user',
              { 'su-team__body_timer_user--active': timer && activeUserIndex === index },
            ]"
            @click="chooseUser(index)"
          >
            <img
              :src="`/v2/school-university/team/${user.img}-small.png`"
              :alt="user.name"
              loading="lazy"
            >
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SuTeam',
  props: {
    title: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    activeTeamId: 1,
    activeUserIndex: 0,
    timer: null,

    /* eslint-disable max-len,vue/max-len */
    team: [
      {
        id: 1,
        btn: 'учителя',
        title: 'регулярно проходят курсы повышения профессиональной квалификации, являются составителями и членами жюри предметных олимпиад',
        items: [
          {
            img: 'oleg',
            name: 'Олег Германович ',
            description: 'главное в&nbsp;подготовке к математике&nbsp;— правильные акценты. я&nbsp;помогу тебе их&nbsp;расставить, сохранить спокойствие и&nbsp;полюбить предмет',
            cheap: ['8 лет опыта', '>1700 учеников', 'МГУ им. М.В. Ломоносова'],
          },
          {
            img: 'alex',
            name: 'Александр Громов',
            description: 'моя&nbsp;миссия&nbsp;— научить ребят «дойти до&nbsp;самой сути», мыслить критически, масштабно, креативно, и&nbsp;всегда выходить за&nbsp;рамки стандартного видения задачи, и&nbsp;смотреть совсем под&nbsp;другим углом',
            cheap: ['9 лет опыта', '>1600 учеников', 'МГУ им. М.В. Ломоносова'],
          },
          {
            img: 'katya',
            name: 'Екатерина Юрьевна',
            description: 'главное&nbsp;— верить в&nbsp;себя и&nbsp;не&nbsp;бояться ошибаться. ошибки&nbsp;— это&nbsp;возможность учиться и&nbsp;расти',
            cheap: ['7 лет опыта', '>1200 учеников', 'красный диплом МПГУ'],
          },
          {
            img: 'mardon',
            name: 'Мардон Модебадзе',
            description: 'моя&nbsp;миссия&nbsp;— вдохновлять детей, погружать в&nbsp;историческое прошлое и&nbsp;давать им&nbsp;возможность самим анализировать факты и&nbsp;события',
            cheap: ['11 лет опыта', '>2500 учеников', 'НИУ ВШЭ'],
          },
        ],
      },
      {
        id: 2,
        btn: 'профориентологи',
        title: 'помогает ученикам сделать осознанный и&nbsp;подходящий выбор вуза и&nbsp;будущей профессии, исследуя истинные желания, таланты и&nbsp;интересы',
        items: [{
          img: 'valya',
          name: 'Валентина Трушкина',
          description: 'если&nbsp;игнорировать профориентации в&nbsp;школе, ребенок может выбрать «не&nbsp;свою» профессию, о&nbsp;которой имеет искаженное представление по&nbsp;сериалам, за&nbsp;компанию с&nbsp;другом, или&nbsp;чтобы угодить родителям',
          cheap: ['5 лет опыта', '>700 учеников', 'Образование МПГУ'],
        }],
      },
      {
        id: 3,
        btn: 'психологи',
        title: 'поддерживает эмоциональное благополучие учеников, помогая им&nbsp;справляться со&nbsp;стрессом, трудностями в&nbsp;учебе,&nbsp;в&nbsp;познании себя и&nbsp;мира&nbsp;вокруг',
        items: [{
          img: 'vera',
          name: 'Вера Липеева',
          description: 'в&nbsp;этом быстроменяющемся мире дети особенно нуждаются в&nbsp;нашей поддержке и&nbsp;внимании. моя&nbsp;задача помочь справиться со&nbsp;стрессом и&nbsp;выбрать профессию по&nbsp;душе',
          cheap: ['5 лет опыта', '>600 консультаций', 'МГППУ'],
        }],
      },
      {
        id: 4,
        btn: 'наставники',
        title: 'индивидуально работают с&nbsp;учениками, помогая им&nbsp;осваивать материал и&nbsp;преодолевать трудности',
        items: [{
          img: 'vika',
          name: 'Виктория Воронова',
          description: 'родителям больше не&nbsp;нужно до&nbsp;вечера делать уроки с&nbsp;ребенком, с&nbsp;домашкой и&nbsp;вопросами помогут профессиональные педагоги-помощники',
          cheap: ['6 лет опыта', 'НИУ ВШЭ «Педагогика и психология»'],
        }],
      },
      {
        id: 5,
        btn: 'тьюторы',
        title: 'помогают «обязательно сдать», выйти на&nbsp;медаль и&nbsp;красный аттестат, расставить фокусы в&nbsp;обучении, организовать учебное пространство и&nbsp;расписание',
        items: [{
          img: 'anzhela',
          name: 'Анжелика Ялова',
          description: 'поддержка + мотивирующая обратная связь + организация времени&nbsp;— формула высокой успеваемости и&nbsp;интереса к&nbsp;учебе',
          cheap: ['6 лет опыта', 'из НИУ ВШЭ «Педагогика и психология»'],
        }],
      },
      {
        id: 6,
        btn: 'методисты',
        title: 'создают понятные, логичные, яркие и&nbsp;порой затягивающие конспекты и&nbsp;тренажеры, чтобы&nbsp;учиться было и&nbsp;увлекательно, и&nbsp;полезно',
        items: [{
          img: 'anna',
          name: 'Анна Сопченко',
          description: 'за внимание ребенка борются игры, приложения, соцсети: чтобы дети стремились к знаниям, образовательный контент должен быть представлен в яркой, понятной, эстетичной форме',
          cheap: ['главный методолог', '8 лет опыта', 'РГЭУ (РИНХ)'],
        }],
      },
    ],
    /* eslint-enable */
  }),
  computed: {
    ...mapGetters({
      windowSize: 'getWindowSize',
    }),
    suTablet() {
      return this.windowSize <= 1200;
    },
    activeTeam() {
      return this.team.find(({ id }) => this.activeTeamId === id);
    },
    activeTeamUser() {
      return this.activeTeam.items[this.activeUserIndex];
    },
  },
  watch: {
    activeTeam() {
      this.stopTimer();
      this.activeUserIndex = 0;
      this.startTimer();
    },
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      if (this.activeTeam.items.length > 1) {
        this.timer = setInterval(() => {
          if (this.activeUserIndex === this.activeTeam.items.length - 1) {
            this.activeUserIndex = 0;
          } else {
            this.activeUserIndex += 1;
          }
        }, 8000);
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    chooseUser(index) {
      this.stopTimer();
      this.activeUserIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
@property --p {
  syntax: '<percentage>';
  inherits: false;
  initial-value: 0%;
}

.su-team {
  .su-title {
    margin-bottom: calc(var(--scale) * 25);
  }

  .su-team__btns {
    margin-bottom: 1.25rem;
    display: flex;
    gap: 0.5rem;

    @include media-down($size-tablet) {
      width: calc(100% + var(--padInline) * 2);
      margin-left: calc(-1 * var(--padInline));
      padding-inline: var(--padInline);

      margin-bottom: calc(var(--scale) * 10);
      overflow-x: auto;
      gap: calc(var(--scale) * 4);
      padding-bottom: calc(var(--scale) * 6);
    }
  }

  .su-team__btn {
    padding: 2rem calc(var(--scale) * 54);
    background-color: #FFFFFF;
    border-radius: 200px;
    transition: 200ms;

    font-style: normal;
    font-weight: 500;
    font-size: 2rem;
    line-height: 110%;
    color: #A7ABAC;

    @media (hover: hover) {
      &:hover {
        color: #5237E6;
      }
    }

    @include media-down($size-tablet) {
      padding: 1.6rem 2.2rem;
      font-size: calc(var(--scale) * 18);
    }

    &--active {
      background-color: #5237E6;
      color: #ffffff !important;
    }
  }

  .su-team__body {
    display: flex;
    gap: calc(var(--scale) * 20);
    justify-content: space-between;
    padding-inline: 2.5rem;

    position: relative;
    background-color: #FFFFFF;
    background-image: url("/v2/school-university/team/bg-figure.svg");
    background-repeat: no-repeat;
    background-position: left top;
    background-size: auto 100%;
    border-radius: 3.75rem;

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 270);
      padding: 2rem 1.6rem;
      gap: calc(var(--scale) * 22);
      border-radius: 2.4rem;

      background-image: url("/v2/school-university/team/bg-figure-tablet.svg");
      background-position: center;
    }

    @include media-down($size-mobile) {
      height: calc(var(--scale) * 512);
      flex-direction: column;
      justify-content: flex-start;
      gap: calc(var(--scale) * 40);
      background-image: url("/v2/school-university/team/bg-figure-mob.svg");
      background-position: bottom center;
    }

    &_title {
      flex-shrink: 0;
      max-width: calc(var(--scale) * 715);
      width: 100%;
      margin-top: 2rem;

      font-style: normal;
      font-weight: 500;
      font-size: 3rem;
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-top: 0;
        max-width: calc(var(--scale) * 334);
        font-size: calc(var(--scale) * 20);
      }
    }

    &_img {
      width: calc(var(--scale) * 445);

      @include media-down($size-tablet) {
        display: none;
      }
    }

    &_info {
      margin-top: calc(var(--scale) * 40);
      padding-bottom: calc(var(--scale) * 40);

      display: flex;
      flex-direction: column;

      @include media-down($size-tablet) {
        margin-top: 0;
        padding-bottom: 0;
      }
    }

    &_cheap {
      margin-bottom: calc(var(--scale) * 16);
      display: flex;
      gap: 0.25rem;

      @include media-down($size-tablet) {
        flex-wrap: wrap;
      }

      span {
        padding: calc(var(--scale) * 10) 1rem;

        background-color: rgba(#02120F, 0.01);
        border: 1px solid #CACACB;
        backdrop-filter: blur(5px);
        border-radius: 2.5rem;

        font-style: normal;
        font-weight: 500;
        font-size: 1rem;
        line-height: 130%;
        color: #02120F;
        white-space: nowrap;

        @include media-down($size-tablet) {
          padding: calc(var(--scale) * 6) calc(var(--scale) * 11);
          font-size: calc(var(--scale) * 14);
        }
      }
    }

    &_name {
      margin-bottom: 0.75rem;

      font-style: normal;
      font-weight: 500;
      font-size: 3rem;
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom: calc(var(--scale) * 8);
        font-size: calc(var(--scale) * 20);
      }
    }

    &_text {
      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 16);
        font-weight: 400;
        line-height: 130%;
        letter-spacing: -0.02em;
      }
    }

    &_timer {
      display: flex;
      gap: 0.5rem;
      margin-top: auto;

      @include media-down($size-tablet) {
        position: absolute;
        left: 1.6rem;
        bottom: 2rem;
        gap: 0.4rem;
      }

      @include media-down($size-mobile) {
        position: static;
        margin-top: 0;
        margin-bottom: calc(var(--scale) * 20);
        order: -1;
      }

      &_user {
        width: 6.25rem;
        aspect-ratio: 1 / 1;
        border-radius: 50%;
        overflow: hidden;

        @include media-down($size-tablet) {
          width: calc(var(--scale) * 80);
        }

        img {
          position: absolute;
          top: 2px;
          left: 2px;
          width: calc(100% - 4px);
          height: calc(100% - 4px);
          border-radius: 50%;
          object-fit: cover;
          object-position: top center;
          background-color: #ecedf0;
        }

        &--active {
          animation-name: timer;
          animation-duration: 8s;
          animation-timing-function: linear;
          background:
            radial-gradient(closest-side, white 95%, transparent 96% 100%),
            conic-gradient(#FF5319 var(--p), #ffffff 0);
        }
      }
    }
  }
}

@keyframes timer {
  to {
    --p: 100%;
  }
}

</style>
